module.exports = __webpack_public_path__ + "static/media/ic-marker-map-convidados.b45a0fb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IconsMap/ic-marker-map-convidados.svg
// module id = 989
// module chunks = 0